import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { SamplesProps } from "../../types/sample";

export interface SamplesState {
  samples: SamplesProps[];
  totalSamples: number;
  isSampleModalOpen: boolean;
  editSample: SamplesProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: SamplesState = {
  samples: [],
  totalSamples: 0,
  isSampleModalOpen: false,
  editSample: null,
  loading: false,
  error: null,
};

type FetchSamplesListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
  status?: number | null;
};

export const fetchSamplesListData = createAsyncThunk(
  "fetchSamplesListData",
  async (req: FetchSamplesListDataProps) => {
    let response: any;
    await GET(`/v1/admin/sample-orders`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const samplesSlice = createSlice({
  name: "samples",
  initialState,
  reducers: {
    toggleSampleModal: (state, action: PayloadAction<boolean>) => {
      state.isSampleModalOpen = action.payload;
    },
    setEditSample: (state, action: PayloadAction<SamplesProps | null>) => {
      state.editSample = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSamplesListData.pending, (state, action: any) => {
      state.samples = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchSamplesListData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.samples = action.payload.data.data.records;
        state.totalSamples = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.samples = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchSamplesListData.rejected, (state, action: any) => {
      state.samples = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { toggleSampleModal, setEditSample } = samplesSlice.actions;

export const getSamples = (state: RootState) => state.samples.samples;

export const getTotalSamples = (state: RootState) => state.samples.totalSamples;

export const getIsSampleModalOpen = (state: RootState) =>
  state.samples.isSampleModalOpen;

export const getEditSample = (state: RootState) => state.samples.editSample;

export default samplesSlice.reducer;
